import { FrameworksBoard } from "../../../../shared/dashboard/FrameworksBoard"
import type { DashboardWidgetProps } from "../widgetRegistry"

export function FrameworksWidget({ stats, loadFailed }: DashboardWidgetProps) {
  return (
    <FrameworksBoard
      frameworks={stats.frameworks}
      loadFailed={loadFailed}
      popLabelKey="MC_SSD_POP_SUPPLIERS"
      coveredHintKey="MC_DASH_SUPPLIER_COVERED_HINT"
    />
  )
}
